import React from 'react';
import Box from '@mui/material/Box';
import { Spinner } from '@uplift/ui';
import { ProviderCard } from '../../../components';
import { StackableCardDeck } from '@uplift/ui-v2';
import { UserMatchOverview } from '@uplift/queries';


type ProviderSidebarProps = {
  matches: UserMatchOverview[];
  isLoading: boolean;
};


export const ProvidersSideBar: React.VFC<ProviderSidebarProps> = ({ matches, isLoading }) => {
  if (isLoading) {
    return (
      <Box my={5}>
        <Spinner />
      </Box>
    );
  }

  return (
    <StackableCardDeck>
      {matches?.map((match, i) => (
        <ProviderCard
          key={match.match.id || i}
          matchId={match.match.id}
          provider={match.provider}
          square
        />
      ))}
    </StackableCardDeck>
  );
};
